import {
  createReducer,
  createFetchReducers,
  createFetchSelectors,
  createFetchActionForNamespace
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('webhooks');

export const fetchWebhooks = createFetchAction({
  name: 'FETCH_WEBHOOKS',
  initialAction: () => ({
    payload: {}
  }),
  stateKey: 'webhooks',
  defaultStateValue: []
});

export const selectWebhooks = createFetchSelectors(fetchWebhooks).data;

export const fetchSchedulerRunsChartData = createFetchAction({
  name: 'FETCH_SCHEDULER_RUNS_CHART_DATA',
  initialAction: ({offset, resolution}) => ({
    payload: {offset, resolution}
  }),
  stateKey: 'schedulerRunesChartData',
  defaultStateValue: []
});
export const selectSchedulerRunsChartData = createFetchSelectors(
  fetchSchedulerRunsChartData
).data;

const initialState = {
  webhooks: [],
  schedulerRunsChartData: []
};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducers(fetchWebhooks),
  ...createFetchReducers(fetchSchedulerRunsChartData)
});

const reducer = (state = initialState, action) => fetchReducers(state, action);

export default reducer;
export {default as webhooksSaga} from './saga';
